import $ from 'jquery';
import 'jquery-match-height';
import 'slick-carousel';
export default {
  init: function init() {},
  finalize: function finalize() {
    var $mainvisual = $('.p-gymtop-trainer-list .slider');

    if ($mainvisual.get(0)) {
      $mainvisual.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1000,
        dots: false,
        arrows: true,
        infinite: true,
        appendArrows: $('.p-gymtop-trainer-list .p-gymtop-trainer-arrowbox'),
        prevArrow: '<a class="prev"></a>',
        nextArrow: '<a class="next"></a>',
        slidesToShow: 3,
        centerMode: true,
        variableWidth: true,
        centerPadding: 0,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    }

    $('.p-gymtop-price-item').matchHeight();
  }
};